export default __webpack_public_path__ + "static/media/beach_5.0a0ae946.jpg";